/** @format */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ModelMapper } from 'model-mapper';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { EquipmentRequest } from '../_classes/equipment-request/equipment-request.class';
import {
  CreateEquipmentRequestDto,
  UpdateEquipmentRequestDto,
} from '../_classes/equipment-request/equipment-request.dto';
import { IHeaderSearch } from '../_classes/header-search';
import { IDatatableOptions, IDatatableRecords } from '../_components/datagrid/datatable.class';

@Injectable({
  providedIn: 'root',
})
export default class EquipmentRequestService {
  constructor(protected http: HttpClient) {}

  public get(id: string): Observable<EquipmentRequest> {
    return this.http
      .get<any[]>(`${environment.apiUrl}/equipment-requests/${id}`)
      .pipe(map(data => new ModelMapper(EquipmentRequest).map(data)));
  }

  public create(dto: CreateEquipmentRequestDto): Observable<EquipmentRequest> {
    return this.http
      .post<any>(`${environment.apiUrl}/equipment-requests`, dto)
      .pipe(map(data => new ModelMapper(EquipmentRequest).map(data)));
  }

  public update(id: string, dto: UpdateEquipmentRequestDto): Observable<boolean> {
    return this.http.patch<boolean>(`${environment.apiUrl}/equipment-requests/${id}`, dto);
  }

  public reject(id: string, reason: string): Observable<boolean> {
    return this.http.patch<boolean>(`${environment.apiUrl}/equipment-requests/${id}/reject`, { reason });
  }

  public validate(id: string): Observable<boolean> {
    return this.http.patch<boolean>(`${environment.apiUrl}/equipment-requests/${id}/validate`, {});
  }

  public remove(id: string): Observable<boolean> {
    return this.http.delete<boolean>(`${environment.apiUrl}/equipment-requests/${id}`);
  }

  public datatable(query: IDatatableOptions, filter: IHeaderSearch): Observable<IDatatableRecords<any>> {
    return this.http.post<any>(`${environment.apiUrl}/equipment-requests/datatable`, { query, filter });
  }

  public referenceExists(reference: string): Observable<string> {
    const params: any = { reference };
    return this.http.get<string>(`${environment.apiUrl}/equipment-requests/reference-exists`, { params });
  }

  public externalReferenceExists(contractorId: string, reference: string): Observable<string> {
    const params: any = { contractorId, reference };
    return this.http.get<string>(`${environment.apiUrl}/equipment-requests/external-reference-exists`, { params });
  }
}
